module.exports = __webpack_public_path__ + "static/media/Jonathon York.0586950c.png";